import React from "react";
import { Trans } from "react-i18next";
import { formatNumber } from "services/util";
import { withProps } from "recompose";


export const PackingSlipLineItems = ({
  invoice,
  lineItemHeaderStyle,
  lineItemStyle,
}) => {
  
  const itemTitle = (item) => {
    let name = ''

    if (item.Item?.Name === item.Description) {
      name = item.Item.Name
    } else if (item.Item?.Name && item.Description) {
      name = item.Item.Name + " - " + item.Description
    } else if (item.Item?.Name) {
      name = item.Item.Name
    } else {
      name = item.Description
    }

    if (item.Item?.Code) {
      name = item.Item.Code + " - " + name
    }

    return name
  }

  return (
    <div className="">
      <table className="table table-sm table--lineitems">
        <thead>
          <tr style={lineItemHeaderStyle}>
            <th>
              <Trans>Description</Trans>
            </th>
            <th className="text-center">
              <Trans>Quantity</Trans>
            </th>
          </tr>
        </thead>
        <tbody style={lineItemStyle}>
          {invoice.LineItems.map((i, idx) => (
            <tr key={idx}> 
              <td style={{ maxWidth: 250 }}>
                { itemTitle(i) }
              </td>
              <td className="text-center">{formatNumber(i.Quantity)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default withProps(() => ({

}))(PackingSlipLineItems);

